import Payment from "../pojos/payment";
import { environment } from "src/environments/environment";
import { Injectable } from "@angular/core";
import { PaymentApiService } from "../api/payment-api.service";
import { BillingInfo } from "./payment-state.service";

@Injectable({
  providedIn: "root",
})
export class RzpPaymentService {
  constructor(private paymentApi: PaymentApiService) {}

  async createPaymentRequestForGymManagementAtRzp(
    planId: string,
    subID: string,
    billingInfo: BillingInfo
  ): Promise<Payment> {
    let createPaymentRequest: any = await this.paymentApi.createPaymentRequest(
      planId,
      subID,
      billingInfo
    );
    let paymentInformation: any = await this.paymentApi.getPaymentInformation(
      createPaymentRequest.data.paymentId
    );
    let paymentInfo: any = paymentInformation.data.paymentInfo;
    let userInfo: any = paymentInformation.data.userInfo;
    let payment = new Payment();
    payment.amount = paymentInfo.amount;
    payment.finalAmount = paymentInfo.finalAmount;
    payment.prefill = {
      name: userInfo.name,
      contact: userInfo.mobile,
      email: userInfo.email,
    };
    payment.notes = {
      paymentId: paymentInfo.paymentId,
    };
    payment.currency = paymentInfo.currency;
    return payment;
  }

  async createPaymentRequestForSmsPlan(
    perSms: number,
    purchaseSms: number,
    subID: string,
    billingInfo: BillingInfo
  ) {
    let createPaymentRequest: any =
      await this.paymentApi.createPaymentRequestForSMS(
        perSms,
        purchaseSms,
        subID,
        billingInfo
      );
    let paymentInformation: any = await this.paymentApi.getPaymentInformation(
      createPaymentRequest.data.paymentId
    );
    let paymentInfo: any = paymentInformation.data.paymentInfo;
    let userInfo: any = paymentInformation.data.userInfo;
    let payment = new Payment();
    payment.amount = paymentInfo.amount;
    payment.finalAmount = paymentInfo.finalAmount;
    payment.prefill = {
      name: userInfo.name,
      contact: userInfo.mobile,
      email: userInfo.email,
    };
    payment.notes = {
      paymentId: paymentInfo.paymentId,
    };
    payment.currency = paymentInfo.currency;
    return payment;
  }

  async createPaymentRequestForBiometric(
    memberCount: number,
    perMemberPerDay: number,
    subID: string,
    billingInfo: BillingInfo
  ) {
    let createPaymentRequest: any =
      await this.paymentApi.createPaymentRequestForBiometric(
        memberCount,
        perMemberPerDay,
        subID,
        billingInfo
      );
    let paymentInformation: any = await this.paymentApi.getPaymentInformation(
      createPaymentRequest.data.paymentId
    );
    let paymentInfo: any = paymentInformation.data.paymentInfo;
    let userInfo: any = paymentInformation.data.userInfo;
    let payment = new Payment();
    payment.amount = paymentInfo.amount;
    payment.finalAmount = paymentInfo.finalAmount;
    payment.prefill = {
      name: userInfo.name,
      contact: userInfo.mobile,
      email: userInfo.email,
    };
    payment.notes = {
      paymentId: paymentInfo.paymentId,
    };
    payment.currency = paymentInfo.currency;
    return payment;
  }

  acceptPaymentFromRzp(payment: Payment, orderId: string) {
    return new Promise((resolve, reject) => {
      var options = {
        key: environment.rzpKey,
        amount: payment.finalAmount,
        currency: payment.currency,
        name: payment.name,
        description: payment.description,
        image: "https://payments.gymbook.in/favicon.ico",
        handler: function (response) {
          resolve(response);
        },
        prefill: payment.prefill,
        notes: payment.notes,
        theme: {
          color: "#009688",
        },
        order_id: orderId,
        config: {
          display: {
            blocks: {
              upi_qr: {
                name: "Pay via UPI QR",
                instruments: [{ method: "upi", flows: ["qr"] }],
              },
            },
            preferences: { show_default_blocks: true },
          },
        },
      };
      // return the global native browser window object
      let _window: any = window;
      let rzp = new _window.Razorpay(options);
      rzp.open();
    });
  }

  async createRzpOrder(
    amount: number | string,
    paymentId: string,
    currency: string
  ) {
    const amountInInteger = Math.ceil(Number(amount));
    let body = {
      amount: amountInInteger,
      receipt: paymentId,
      currency: currency || "INR",
    };

    let paymentInformation: any = await this.paymentApi.createRzpOrder(body);
    let data;
    if (paymentInformation) {
      data = paymentInformation.data.id;
    }
    return data;
  }
}
